import React, { useEffect, useState } from "react";
import { IconContainer } from "../../components/common/IconContainer";
import { IconsChevronLeft } from "../../icons/IconsChevronLeft";
import { fetchQuestionList, postUserChoice } from "../../ServerCall";
import { toast } from "react-toastify";
import { toastObj, updateQueryParams } from "../../utils/commanFunctions";
import CircularLoading from "../common/Loader/CircularLoading";
import { useNavigate } from "react-router";
import { Header } from "../common/Header";
import LoadingScreen from "./LoadingScreen";
import { trackPersonalizedFlow } from "../../utils/FunctionsForGa";
import configs from "../../contentConfig";

const flowConfig = configs?.explore?.personaliseYourStay?.flow || {};
const alwaysShowContinue = flowConfig.alwaysShowContinue ?? false;
const showPrevious = flowConfig.showPrevious ?? false;

 const PersonalizedStayUI = () => {

  const navigate = useNavigate()

  useEffect(() => {
      (async () => {
        let data = await fetchQuestionList();
        if (data.status) setSteps(data.data);
      })();
  }, []);

  const [steps, setSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [complete, setComplete] = useState(false);
  const [selection, setSelection] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  if (steps.length && steps[currentStep - 1]) {
    const stepData = steps[currentStep - 1];
    trackPersonalizedFlow({
      action: `step_${currentStep}`,
      question: stepData.text,
      choices: stepData.options?.join(", "),
      selection_name: selection[stepData.id]?.selected_options?.join(", ") || "",
      step: currentStep
    });
  }
}, [currentStep, steps]);

  

  const handleSelection = (data, ele) => {
    const { id, max_selection = 1, min_selection = 1 } = data;
    const updatedSelection = { ...selection };

    if (updatedSelection[id]) {
      const index = updatedSelection[id]["selected_options"].indexOf(ele);

      if (index !== -1) {
        updatedSelection[id]["selected_options"].splice(index, 1);
      } else {
        if (updatedSelection[id]["selected_options"].length >= max_selection)
         {
          toast.warn("Oops, you can select a maximum of "+max_selection,toastObj);
          return;
         }
        updatedSelection[id]["selected_options"].push(ele);
      }
    } else {
      updatedSelection[id] = {
        question: data.text,
        selected_options: [ele],
      };
    }

    setSelection(updatedSelection);
  };
  const handleComplete = async () => {
    setLoading(true)
    let data = Object.values(selection);
    console.log(data);
    trackPersonalizedFlow({
  action: "submit",
  question: "",
  choices: "",
  selection_name: Object.values(selection)
    .map((q) => `${q.question}: ${q.selected_options.join(", ")}`)
    .join(" | "),
  step: currentStep
});


    let res = await postUserChoice(data, null, setComplete, setCurrentStep, setSelection,setLoading);
    if (res.status) {
      let events = [];
      let places = [];
      let allPlaceAndEvent = []
      for (let i of res.data) {
        if (i.type === "PLACE") {
          places.push(i);
        } else if (i.type === "EVENT") {
          events.push(i);
        }
        allPlaceAndEvent.push(i)
      }
      let appData = localStorage.getItem("appData");
      if (appData) {
        appData = JSON.parse(appData); 
        appData = {
          ...appData,
          places,
          events,
          allPlaceAndEvent
        };
        localStorage.setItem("appData", JSON.stringify(appData)); 
      } else {
        let data = {};
        data.places = places;
        data.events = events;
        data.allPlaceAndEvent = allPlaceAndEvent
        localStorage.setItem("appData", JSON.stringify(data)); 
      }
      // localStorage.setItem("filter","Personalized")
      if(localStorage.getItem('preservedData'))
      localStorage.removeItem("preservedData")
      // toast.success("Choices are saved successfully",toastObj);
      const path =  updateQueryParams({
        path:"personalizedStayPage"
      })
      navigate(path)
    } else {
      console.log(res);
      toast.error("Something went wrong please try again",toastObj);
      
    }
    
  };
  return (
<>
{
  loading && <div className="absolute z-[999] w-full h-full"><LoadingScreen variant="minimal"/></div>
}

{/* <Header  data={{
            title:'PERSONALIZED STAY',
            eventType:"INNSPIRE_GO_HOME",
            eventData:{}
          }}
            showFilter={false}
            showSearch={false}
            showBookMark={false}
            showBack={false}
  /> */}
{
   steps.length > 0 ? <>
   <div className="pers-stay-ui-container-main flex flex-col w-[100vw] h-[95vh] mt-[44px] max-w-[1000px] mx-auto items-start gap-6 pb-10 px-0 relative bg-white rounded-t-[10px]">
  

  <div className="relative w-[100%] border-b-[0.5px] [border-bottom-style:solid] border-[#3c3c435c] hide-top-bar">
    <div
                   onClick={() => {
                    if(currentStep === 1)
                    {
                      if(window.GoBackToParent)
                        window.GoBackToParent() 
                      else
                      navigate(-1)
                      return
                    }
                    if(!complete)
                    setComplete(false);
                    setCurrentStep((prev) => prev - 1);
                  }}
                  // ${currentStep === 1 && "invisible"}
    className={`p-[8px] flex justify-start items-center min-h-[50px] hide-top-bar`}>

    <IconContainer
              className=""
              icon={
                <IconsChevronLeft
                  className="!relative !flex-1 !self-stretch !grow"
                  color="black"
                />
              }
              size="default"
            />
            <div className={`relative w-fit mt-[2px] font-secondary font-body-text-base font-[number:var(--body-text-base-font-weight)] text-wwwstanfordcourtcomblack text-[length:var(--body-text-base-font-size)] tracking-[var(--body-text-base-letter-spacing)] leading-[var(--body-text-base-line-height)] whitespace-nowrap [font-style:var(--body-text-base-font-style)]`}>
              Back
            </div>
    </div>
  </div>
  <div className="justify-between p-4 flex-1 grow flex flex-col items-start relative self-stretch w-full pers-steps-content">
    <div className="gap-2 flex flex-col items-start relative self-stretch w-full">
      <div className="relative w-fit mt-[-1.00px]font-secondary font-medium text-[#888888] text-sm tracking-[0] leading-[16.1px] whitespace-nowrap step-2-text-before">
        Step {currentStep} of {steps.length}
      </div>

      <div className="relative w-fit font-medium text-[#1a1a1a] xs:text-5xl text-3xl tracking-[0] leading-10 step-2-text">
      { steps[currentStep - 1]["text"]}
      </div>
      <p className="text-sm text-gray-400 font-secondary step-2-text-after">
          Choose Min {steps[currentStep - 1]["min_selection"]} and Max{" "}
          {steps[currentStep - 1]["max_selection"]}
        </p>
    </div>

      

    <div className="gap-8 flex-[0_0_auto] flex flex-col items-start relative self-stretch">
    <div className={`flex flex-wrap items-start gap-[8px_8px] relative self-stretch w-full flex-[0_0_auto] ${steps[currentStep - 1]?.options.length < 8 && 'box-config'}`}>

      {steps[currentStep - 1]?.options &&
          steps[currentStep - 1]?.options.map((e) => (
            <div
            key={e}
            onClick={() => handleSelection(steps[currentStep - 1], e)} 
            className={`text-[#1a1a1a] inline-flex items-start gap-1 xs:px-4 xs:py-3 px-2 py-2 relative flex-[0_0_auto] bg-[#f6f6f6] rounded-lg ${steps[currentStep - 1]?.options.length >= 8 ?'inside-box-config':'inside-box-config-less-than-8'}`}
            style={{
              ...(selection[steps[currentStep - 1]["id"]]?.selected_options?.includes(e) && {
                background: "var(--color-primary)",
                color: "white",
              }),
              ...(steps[currentStep - 1]?.options.length <= 8 && {
                padding: "12px 16px 32px",
                width: "45%",
              }),
            }}
            >
            <div style={{...(selection[steps[currentStep - 1]["id"]]?.selected_options?.includes(e) && {
                color: "white",
              })}} className="relative w-fit mt-[-2.00px] font-secondary font-medium xs:text-base text-[16px] tracking-[0] leading-[18.4px] whitespace-nowrap inside-box-config-text">
              {e}
            </div>
          </div>  

          ))}

      </div>

      {(() => {
        const selectedCount =
          selection[steps[currentStep - 1]?.id]?.selected_options?.length || 0;
        const isValid =
          selectedCount >= steps[currentStep - 1]?.min_selection &&
          selectedCount <= steps[currentStep - 1]?.max_selection;
        const handlePrevious = () => {
          if (currentStep === 1) {
            if (window.GoBackToParent) window.GoBackToParent();
            else navigate(-1);
            return;
          }
          if (!complete) setComplete(false);
          setCurrentStep((prev) => prev - 1);
        };
        const continueVisibilityClass = alwaysShowContinue
          ? isValid
            ? "opacity-100 cursor-pointer"
            : "opacity-40 cursor-not-allowed"
          : isValid
            ? "visible"
            : "invisible";
        return (
          <div className="flex flex-col gap-2 self-stretch w-full xs:mb-[50px] mb-[40px]">
            <div
              onClick={() => {
                if (!isValid) return;
                currentStep === steps.length
                  ? handleComplete()
                  : setCurrentStep((prev) => prev + 1);
              }}
              className={`${continueVisibilityClass} all-[unset] box-border flex h-12 items-center justify-center gap-1 xs:px-6 px-3 xs:py-2 py-1 relative self-stretch w-full bg-wwwstanfordcourtcomthunder rounded-lg pers-init-ui-button`}
            >
              <button className={`all-[unset] box-border relative w-fit font-medium text-white text-[14px] tracking-[0] leading-[18.4px] whitespace-nowrap`}>
                {currentStep === steps.length ? "Finish" : "Continue"}
              </button>
            </div>
            {showPrevious && (
              <div
                onClick={handlePrevious}
                className="all-[unset] box-border flex h-12 items-center justify-center gap-1 xs:px-6 px-3 xs:py-2 py-1 relative self-stretch w-full rounded-lg cursor-pointer pers-init-ui-button-outline"
              >
                <button className="all-[unset] box-border relative w-fit text-[14px] tracking-[0] leading-[18.4px] whitespace-nowrap">
                  Previous
                </button>
              </div>
            )}
          </div>
        );
      })()}
    </div>
  </div>


</div>
  </>:<></>
}
</>
  
  );
};

export default PersonalizedStayUI

